import { formatLocationPath } from '@cheqroom/api';
import { getIcon } from '@cheqroom/icons';
import { FC } from 'react';

import { Info } from '../../Info';
import { useItemInfoContext } from '../ItemInfo.context';

export const Location: FC = () => {
	const { item } = useItemInfoContext();

	if (!item.location) return null;

	const IconComponent = getIcon(item.location.icon, 'Marker');

	const locationPath = formatLocationPath(item.locationPath, item.location.name);

	return <Info icon={IconComponent} text={locationPath} />;
};
